import React from 'react';
import classNames from 'classnames';
import { PopUp } from '@beisen/chaos-ui';
import transLoader from '@beisen/i18n-translation-loader';
require('./Notice.scss');

const defaultTranslation = {
    defaultNoticeTitle: '公告',
    notShowNotice: '不再提示',
    iKnow: '我知道了'
};
class NoticeModal extends React.Component {
    constructor(props) {
        super(props);
        this.onClose = this.onClose.bind(this);
        this.onCloseForever = this.onCloseForever.bind(this);
        this.state = {
            canScroll: false
            ,canShowTopModal: false
            ,canShowBottomModal: false
        };
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            defaultNoticeTitle: 'modal.defaultNoticeTitle',
            notShowNotice: 'modal.notShowNotice',
            iKnow: 'modal.iKnow'
        }), props.translation);
    };
    componentDidMount() {
        const noticeMsg = this.refs.noticeMsg;
        const containerHeight = noticeMsg.clientHeight;
        const scrollHeight = noticeMsg.scrollHeight;
        this.canScroll = containerHeight < scrollHeight;
        this.setState({ canScroll: this.canScroll });
        const scrollPathHeight = scrollHeight - containerHeight;
        if(noticeMsg && this.canScroll) {
            this.setState({ canShowBottomModal: true });
            noticeMsg.addEventListener('scroll',e => {
                if(e.target.scrollTop != 0 && !this.state.canShowTopModal) {
                    this.setState({ canShowTopModal: true });
                }else if(e.target.scrollTop == 0 && this.state.canShowTopModal) {
                    this.setState({ canShowTopModal: false });
                }
                if(e.target.scrollTop != scrollPathHeight && !this.state.canShowBottomModal) {
                    this.setState({ canShowBottomModal: true });
                }else if(e.target.scrollTop == scrollPathHeight && this.state.canShowBottomModal) {
                    this.setState({ canShowBottomModal: false });
                }
            });
        }
    }

    onClose(e) {
        e.preventDefault();
	    e.stopPropagation();
        this.props.onClose && this.props.onClose();
    }
    onCloseForever(e) {
        e.preventDefault();
        e.stopPropagation();
        this.props.onCloseForever && this.props.onCloseForever();
    }
    render() {
        const { translation } = this;
		const { visible,style,maskStyle,bodyStyle,animation,maskAnimation,transitionName,noticeIcon,noticeTitle,noticeMsg,leftButtonName,rightButtonName } = this.props;
		return (
			<PopUp style={style}
			       cls='modal_popup'
                   wrapClassName="notice_popup"
	               maskStyle={maskStyle || { backgroundColor: 'rgba(0,0,0,.1)' }}
	               bodyStyle={bodyStyle}
	               visible={visible}
	               animation={animation || 'zoom'}
	               maskAnimation={maskAnimation || 'fade'}
	               transitionName={transitionName}
	               onClose={this.onClose}
                   maskClosable={false}
			>
				<div className={classNames('notice-container',{ 'lang-en': window.userLang == 'en_US' })}>
                    {noticeIcon || <span className="notice-icon center" />}
                    <p className="notice-title">{noticeTitle || translation.defaultNoticeTitle}</p>
                    <div className={classNames('notice-content'
                                                ,{ 'canScroll': this.state.canScroll
                                                    ,'canShowTopModal': this.state.canShowTopModal
                                                    ,'canShowBottomModal': this.state.canShowBottomModal })}>
                        <span className="topModal" />
                        <div className="notice-msg" ref="noticeMsg">{noticeMsg}</div>
                        <span className="bottomModal" />
                    </div>
                    <div className="notice-button not-show-button" onTouchTap={this.onCloseForever}>{leftButtonName || translation.notShowNotice}</div>
                    <div className="notice-button i-know-button" onTouchTap={this.onClose}>{rightButtonName || translation.iKnow}</div>
                </div>
			</PopUp>
	    );
    }
};

NoticeModal.defaultProps = {
  show: false
};

export default NoticeModal;



// WEBPACK FOOTER //
// ./src/components/Notice/Notice.js